import React from 'react'
import ImageNotAvailable from '../../assets/image-not-available.png'
import PlayIcon from '../../assets/Content-Icons/Svgs/play-circle.svg'
import CustomImage from 'src/components/customImage/customImage'
import InformationTagIcon from '../../assets/Content-Icons/Svgs/information-tag-icon.svg'
import TanscodingFailureIcon from '../../assets/tanscoding-failure-icon.svg'
import { isEmpty } from 'lodash'
import { Dropdown } from 'react-bootstrap'
import OptionsBtn from '../../assets/elipsis-icon.svg'

const BasicDisplayCard = ({
  cardImage = '',
  playIconForVideo = false,
  actionButtonOptions = [],
  fileName = '',
  leftText = '',
  rightText = '',
  transcodingError = '',
}) => {
  return (
    <div
      style={{
        width: '15.25%',
        aspectRatio: '183/134',
        boxShadow: ' 3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        border: `.5px solid #707070`,
      }}
      className="basic-display-card"
      tabIndex={0}
    >
      <div className="relative " style={{ height: '74%' }}>
        <div className="overflow-hidden h-100 d-flex justify-content-center align-items-center ">
          <CustomImage
            className="card-img-top w-auto h-auto"
            imageUrl={cardImage}
            loaderStyle={{ height: '100%' }}
            errorPlaceholder={ImageNotAvailable}
            alt={'Asset'}
            imgStyle={{
              opacity: !transcodingError ? '1' : '.36',
              pointerEvents: !transcodingError ? 'all' : 'none',
              maxHeight: '6.4vw',
              maxWidth: '100%',
              zIndex: '1',
            }}
          />
        </div>
        {transcodingError && (
          <div
            className={`${
              transcodingError === 'PROGRESS' ? 'information-tag' : 'transcode-fail-tag'
            }  `}
            style={{ zIndex: '10' }}
          >
            <img
              src={transcodingError === 'PROGRESS' ? InformationTagIcon : TanscodingFailureIcon}
              alt="TanscodingFailureIcon"
            />
          </div>
        )}
        {playIconForVideo && (
          <div
            className="play-icon"
            style={{
              opacity: !transcodingError ? '1' : '.36',
              pointerEvents: !transcodingError ? 'all' : 'none',
              zIndex: '10',
            }}
          >
            <img src={PlayIcon} alt="" />
          </div>
        )}
      </div>
      <div className="d-flex justify-content-between px-1">
        <div style={{ fontSize: '10px', width: '88%', opacity: !transcodingError ? '1' : '.36' }}>
          <h6
            className="line-clamp-1"
            style={{ fontSize: '11px', margin: '.2ch 0', color: '#000' }}
          >
            {fileName}
          </h6>
          <div className="d-flex justify-content-between">
            <span>{leftText}</span>
            <span>{rightText}</span>
          </div>
        </div>
        {!isEmpty(actionButtonOptions) && (
          <div
            style={{
              width: '6%',
              fontSize: '20px',
              fontWeight: '700',
              cursor: 'pointer',
            }}
            className="d-flex justify-content-center align-items-center position-relative preview-menu-dots"
          >
            <Dropdown align="center" className="">
              <Dropdown.Toggle variant="ghost" className="" id="revenue-dropdown">
                <img src={OptionsBtn} alt="OptionsBtn" />
              </Dropdown.Toggle>

              <Dropdown.Menu className="p-0 w-fit">
                {actionButtonOptions.map((info, idx) => (
                  <Dropdown.Item
                    key={idx}
                    style={{ cursor: 'pointer', fontSize: '12px' }}
                    onClick={() => {
                      info?.btnFunction()
                    }}
                    className="d-flex "
                  >
                    {info?.logo ? info?.logo : null}
                    {info?.name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}
      </div>
    </div>
  )
}

export default BasicDisplayCard
